import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { AddMemberComponent } from './components/add-member/add-member.component';
import { MemberManagementComponent } from './components/member-management/member-management.component';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AuthGuardService as AuthGuard } from '../../../shared/services/auth.guard';

const teamRoutes: Routes = [
  {
    path: 'add/member',
    component: AddMemberComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'mangement',
    component: MemberManagementComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "edit-member/:token",
    component: AddMemberComponent,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [
    AddMemberComponent,
    MemberManagementComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(teamRoutes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
  ]
})
export class TeamModule { }
